import React from 'react';
import { Badge } from 'react-bootstrap';
import { FolderSymlinkFill } from 'react-bootstrap-icons';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import momencik from '../../../common/momencik';
import { GetVisitRegistrationDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface VisitRegistrationSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  initialOrderColumn?: string;
  initialOrderDirection?: 'DESC' | 'ASC';
  withFilterInColumns?: boolean;
}

export const visitForGrid = (visit: GetVisitRegistrationDto) => {
  return {
    key: visit.id,
    values: {
      'visitRegistration.visitDateTime':
        momencik(visit.visitDateTime, 'YYYY-MM-DD HH:mm') || '',
      'visitRegistration.visitTime': visit.visitTime
        ? `${visit.visitTime} min`
        : '',
      'visitRegistration.surname': visit.surname || '',
      'visitRegistration.firstname': visit.firstname || '',
      'visitRegistration.mail': visit.mail || '',
      'visitRegistration.phone': visit.phone || '',
      'healthcareFacility.displayName':
        visit.appointmentChannel?.healthcareFacility?.displayName || '',
      'examType.name': visit.examType?.name || '',
      'exam.number': visit.exam?.number ? (
        <Badge bg="success">{visit.exam.number}</Badge>
      ) : (
        ''
      ),
      payments:
        visit.payments && visit.payments.length > 0 ? (
          <Badge bg="info">💰</Badge>
        ) : (
          ''
        ),
      creator_name: (
        <>
          {visit.creatorName || ''}
          {visit.externalBooking && (
            <FolderSymlinkFill className="ms-2 icon-blue" size={16} />
          )}
        </>
      ),
    },
  };
};

export const VisitRegistrationSearch: React.FC<
  VisitRegistrationSearchProps
> = props => {
  const columns = [
    { header: 'Data i godzina', property: 'visitRegistration.visitDateTime' },
    { header: 'Nazwisko', property: 'visitRegistration.surname' },
    { header: 'Imię', property: 'visitRegistration.firstname' },
    { header: 'E-mail', property: 'visitRegistration.mail' },
    { header: 'Telefon', property: 'visitRegistration.phone' },
    { header: 'Placówka', property: 'healthcareFacility.displayName' },
    { header: 'Czas', property: 'visitRegistration.visitTime' },
    { header: 'Typ badania', property: 'examType.name' },
    { header: 'Badanie', property: 'exam.number' },
    {
      header: 'Płatności',
      property: 'payments',
      noSorting: true,
      noFilter: true,
    },
    { header: 'Utworzył', property: 'creator_name' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      withHistory={true}
      initialOrderColumn={
        props.initialOrderColumn || 'visitRegistration.visitDateTime'
      }
      initialOrderDirection={props.initialOrderDirection || 'DESC'}
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak wizyt w systemie"
      refresh={props.refresh}
      withFilterInColumns={props.withFilterInColumns}
    />
  );
};
